import PayModal from '../PayModal/pay-modal';

export default PayModal;